'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = require('@arreeba/ristoranti-lib/lib/util');

var _constants = require('../constants');

exports.default = _extends({}, (0, _util.createActionObject)('loadMenu', _constants.LOAD_MENU_START, _constants.LOAD_MENU_SUCCESS, _constants.LOAD_MENU_FAILURE), (0, _util.createActionObject)('createCardToken', _constants.CREATE_CARD_TOKEN_START, _constants.CREATE_CARD_TOKEN_SUCCESS, _constants.CREATE_CARD_TOKEN_FAILURE), (0, _util.createActionObject)('orderFetchExtraCosts', _constants.ORDER_FETCH_EXTRA_COSTS_START, _constants.ORDER_FETCH_EXTRA_COSTS_SUCCESS, _constants.ORDER_FETCH_EXTRA_COSTS_FAILURE), {
  configureItem: function configureItem(item) {
    return {
      type: _constants.MENU_CONFIGURE_ITEM,
      item: item
    };
  },
  addToCart: function addToCart(item) {
    return {
      type: _constants.MENU_CART_ADDITEM,
      item: item
    };
  },
  removeFromCart: function removeFromCart(item) {
    return {
      type: _constants.MENU_CART_REMOVEITEM,
      item: item
    };
  },
  resetCart: function resetCart() {
    return {
      type: _constants.MENU_CART_RESET
    };
  },
  showErrors: function showErrors(bool) {
    return {
      type: _constants.MENU_SHOW_ERRORS,
      bool: bool
    };
  }
}, (0, _util.createActionObject)('deliveryAddressCheck', _constants.DELIVERY_ADDRESS_CHECK_START, _constants.DELIVERY_ADDRESS_CHECK_SUCCESS, _constants.DELIVERY_ADDRESS_CHECK_FAILURE), (0, _util.createActionObject)('deliveryAddressUpdate', _constants.DELIVERY_ADDRESS_UPDATE_START, _constants.DELIVERY_ADDRESS_UPDATE_SUCCESS, _constants.DELIVERY_ADDRESS_UPDATE_FAILURE), {
  setDeliveryAddress: function setDeliveryAddress(_ref) {
    var description = _ref.description,
        geometry = _ref.geometry,
        addressComponents = _ref.addressComponents;

    return {
      type: _constants.DELIVERY_SET_ADDRESS,
      addressComponents: addressComponents,
      location: {
        geometry: geometry,
        description: description
      }
    };
  },
  updateDeliveryAddressExtraInfo: function updateDeliveryAddressExtraInfo(data) {
    return {
      type: _constants.DELIVERY_UPDATE_EXTRA_INFO,
      data: data
    };
  },
  reloadOrder: function reloadOrder(order) {
    return {
      type: _constants.ORDER_RELOAD,
      order: order
    };
  },
  setDateTimeDelivery: function setDateTimeDelivery(_ref2) {
    var date = _ref2.date,
        time = _ref2.time;

    return {
      type: _constants.DELIVERY_SET_DATE_TIME,
      deliveryDate: date,
      deliveryTime: time
    };
  },
  setOrderType: function setOrderType(orderType) {
    return {
      type: _constants.DELIVERY_SET_ORDER_TYPE,
      orderType: orderType
    };
  },
  setOrderTypeDelivery: function setOrderTypeDelivery() {
    return {
      type: _constants.DELIVERY_SET_ORDER_TYPE,
      orderType: _constants.ORDER_TYPE_DELIVERY
    };
  },
  setOrderTypeTakeAway: function setOrderTypeTakeAway() {
    return {
      type: _constants.DELIVERY_SET_ORDER_TYPE,
      orderType: _constants.ORDER_TYPE_TAKEAWAY
    };
  },
  setDeliveryData: function setDeliveryData(data) {
    return {
      type: _constants.DELIVERY_SET_ORDER_DATA,
      data: data
    };
  },
  setTakeAwayRestaurant: function setTakeAwayRestaurant(restaurantId) {
    return {
      type: _constants.TAKEAWAY_SET_RESTAURANT,
      id: restaurantId
    };
  },
  setPaymentMethod: function setPaymentMethod(method) {
    return {
      type: _constants.PAYMENT_SET_METHOD,
      method: method
    };
  },
  setPaymentCreditCard: function setPaymentCreditCard() {
    return {
      type: _constants.PAYMENT_SET_METHOD,
      method: _constants.PAYMENT_METHOD_CC
    };
  },
  setPaymentUnhandled: function setPaymentUnhandled(amount) {
    return {
      type: _constants.PAYMENT_SET_METHOD,
      method: _constants.PAYMENT_UNHANDLED,
      amount: amount
    };
  },
  setCheckoutFormData: function setCheckoutFormData(data) {
    return {
      type: _constants.ORDER_SET_CHECKOUT_FORM,
      data: data
    };
  },
  setNewCreditCardFormData: function setNewCreditCardFormData(data) {
    return {
      type: _constants.ORDER_NEW_CC_SETFORM,
      data: data
    };
  },
  resetOrderState: function resetOrderState() {
    var keep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return {
      type: _constants.ORDER_RESET,
      keep: keep
    };
  }
}, (0, _util.createActionObject)('storeOrder', _constants.STORE_ORDER_START, _constants.STORE_ORDER_SUCCESS, _constants.STORE_ORDER_FAILURE), {
  updateCurrentOrder: function updateCurrentOrder(order) {
    return {
      type: _constants.UPDATE_CURRENTORDER,
      order: order
    };
  },
  addVoucher: function addVoucher(voucherID) {
    return {
      type: _constants.ORDER_ADD_VOUCHER,
      voucherID: voucherID
    };
  },
  toggleAsap: function toggleAsap(status) {
    return {
      type: _constants.ORDER_TOGGLE_ASAP,
      status: status
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/actions/order.js
// module id = 410
// module chunks = 0